export default __webpack_public_path__ + "static/media/restaurantes.43c08d58.jpg";